module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-04-51c05c2b.webp";